const Style = {}

export default Style;